import { type FC, type ReactNode } from "react";

import { css } from "@emotion/css";

import { SkeletonContainer } from "../../common/components";

interface CardWithBannerSkeletonContainerProps {
    loading: boolean;
    children: ReactNode;
}

export const CardWithBannerSkeletonContainer: FC<CardWithBannerSkeletonContainerProps> = ({ loading, children }) => (
    <>
        <SkeletonContainer loading={loading} height={240} className={skeletonStyle} />
        <SkeletonContainer loading={loading} height={500} className={skeletonStyle}>
            {children}
        </SkeletonContainer>
    </>
);

const skeletonStyle = css`
    margin: 20px 0;
`;
